import { render, staticRenderFns } from "./leftnav.vue?vue&type=template&id=220d21dd&scoped=true"
import script from "./leftnav.vue?vue&type=script&lang=js"
export * from "./leftnav.vue?vue&type=script&lang=js"
import style0 from "./leftnav.vue?vue&type=style&index=0&id=220d21dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d21dd",
  null
  
)

export default component.exports